import { render, staticRenderFns } from "./JoinRoom.vue?vue&type=template&id=b687d9be&scoped=true&"
import script from "./JoinRoom.vue?vue&type=script&lang=js&"
export * from "./JoinRoom.vue?vue&type=script&lang=js&"
import style0 from "./JoinRoom.vue?vue&type=style&index=0&id=b687d9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b687d9be",
  null
  
)

component.options.__file = "JoinRoom.vue"
export default component.exports